import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-home-four',
    templateUrl: './home-four.component.html',
    styleUrls: ['./home-four.component.scss'],
    standalone: false
})
export class HomeFourComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
